import { render } from "./비급여진료비용.vue?vue&type=template&id=60b934d4"
import script from "./비급여진료비용.vue?vue&type=script&lang=js"
export * from "./비급여진료비용.vue?vue&type=script&lang=js"

import "./비급여진료비용.vue?vue&type=style&index=0&id=60b934d4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__